import {BUSCAR_PRESTADORES, BUSCAR_PRESTADORES_SIMPLES, SELECIONAR_PRESTADOR} from '../../actions/types'

const initial = {
  prestadores: [],
  prestadorSelecionado: null,
  prestadoresSimples: []
}

export default function reducerPrestadores (state = initial, action) {
  switch (action.type) {
    case BUSCAR_PRESTADORES: {
      return {
        ...state,
        prestadores: action.payload.data.prestadores,
        total: action.payload.data.total
      }
    }

    case BUSCAR_PRESTADORES_SIMPLES: {
      return {
        ...state,
        prestadoresSimples: action.payload.data
      }
    }

    case SELECIONAR_PRESTADOR: {
      return {
        ...state,
        prestadorSelecionado: action.payload
      }
    }

    default: {
      return state
    }
  }
}
